import { routes } from "~/core/constants/routes";

import {
  faCalendar,
  faCheck,
  faPhone,
} from "@fortawesome/pro-regular-svg-icons";

import { SubscriptionStatus } from "../enums";
import { Feature } from "../types";

export const MAX_USAGE = 1000;

export const FEATURES: Feature[] = [
  {
    label: "Unlimited seats — Bring the whole team",
    icon: faCheck,
    unlimited: true,
  },
  {
    label: "Meeting recordings — Auto-logged",
    icon: faCheck,
  },
  {
    label: "Contact object — Prospect freely",
    icon: faCheck,
  },
  {
    label: "Account object — All tracked",
    icon: faCheck,
  },
  {
    label: "Workflow runs — Automate everything",
    icon: faCheck,
  },
  {
    label: "Form builder — Capture data",
    icon: faCheck,
  },
  {
    label: "Direct access to founder calendar",
    icon: faCalendar,
  },
  {
    label: "Direct phone support from CEO",
    icon: faPhone,
  },
];

export const MODAL_FORBIDDEN_ROUTES = [
  "/security",
  "/terms",
  "/home",
  "/privacy-policy",
  "/subprocessor",
  "/subscription/callback",
  routes.auth.signIn,
  routes.redirect,
  routes.auth.onboarding,
];

export const MODAL_ALLOWED_STATUS = [
  SubscriptionStatus.INCOMPLETE_EXPIRED,
  SubscriptionStatus.CANCELED,
  SubscriptionStatus.PAST_DUE,
  SubscriptionStatus.UNPAID,
  SubscriptionStatus.INACTIVE,
];
